/**
 * TÍNH LÁ SỐ SỚM, TRONG WEB WORKER.
 *
 * Bệnh: `chart7()` chạy đồng bộ trên main thread đúng lúc dựng màn kết quả. Đo trên live
 * 15/09/2026 theo đúng đường khách thật (`bdate → name → email → calc → hub`), ngày sinh mới
 * chưa có trong cache:
 *
 *     bdate · name · email · calc   21–29 ms
 *     hub                            2.938 ms      ← ở CPU 6×
 *
 * Riêng `chart7()`: 451 ms (1×) · 1.578 ms (4×) · 2.367 ms (6×).
 *
 * Cách chữa KHÔNG phải là biến `chart7()` thành bất đồng bộ: nó được gọi ở sáu chỗ và kết quả
 * dùng ngay để dựng HTML, sửa hết là sửa vào file bê nguyên. Thay vào đó lợi dụng chính bộ nhớ
 * đệm mà bundle đã có:
 *
 *     var _chart = null, _chartSig = '', _chartErr = null;
 *     function chart7(){ … if(_chart && _chartSig === sig) return _chart; … }
 *
 * Ba biến đó khai bằng `var` ở top-level nên là biến TOÀN CỤC. Worker tính xong thì nạp thẳng
 * kết quả vào đó. Tới màn `hub`, `chart7()` thấy chữ ký khớp và trả về sau 0 ms — không một dòng
 * nào của bundle phải sửa.
 *
 * Khi nào tính: sau mỗi lần đổi màn, hễ đã có ngày sinh là gửi. Thực tế rơi vào quãng khách đang
 * gõ tên và email — hai chục giây main thread gần như rảnh, còn worker thì chạy ở luồng khác nên
 * ô nhập không khựng.
 *
 * Chưa kịp xong thì KHÔNG sao: `chart7()` tự tính đồng bộ như cũ. Đây là đường tắt, không phải
 * đường độc đạo — worker hỏng, trình duyệt cũ, engine không tải được, tất cả đều rơi về hành vi
 * nguyên bản.
 *
 * Vì sao worker dựng từ Blob thay vì trỏ thẳng vào tệp asset: `new Worker(url)` đòi cùng nguồn,
 * mà asset Shopify có thể được phục vụ qua một nguồn khác. Blob thì luôn cùng nguồn, rồi bên
 * trong `importScripts` kéo engine về — lời gọi đó thì cho phép khác nguồn.
 */
(function () {
  'use strict';

  if (typeof Worker !== 'function' || typeof Blob !== 'function') return;
  if (typeof goto !== 'function') return;

  /* Engine đã tách khỏi bundle — xem bin/q2_tach_engine_astro.py. `__qzAsset` do phép cắt nhạc
     chèn vào đầu bundle (bin/q1_cat_nhac_anh.py); thiếu nó thì không dựng được URL, thôi không
     làm gì và để mọi thứ chạy như cũ. */
  if (typeof __qzAsset !== 'function') return;

  var urlEngine;
  try {
    urlEngine = new URL(__qzAsset('qz-astro-engine.js'), location.href).href;
  } catch (e) { return; }

  var MA_WORKER =
    'importScripts(' + JSON.stringify(urlEngine) + ');\n' +
    'self.onmessage = function (e) {\n' +
    '  var v = e.data || {};\n' +
    '  try {\n' +
    '    var c = ASTRO.chart(v.y, v.m, v.d, v.hh, v.mm, v.place, v.name, v.q7);\n' +
    '    self.postMessage({ sig: v.sig, chart: c });\n' +
    '  } catch (err) {\n' +
    '    self.postMessage({ sig: v.sig, loi: String(err && err.message || err) });\n' +
    '  }\n' +
    '};\n';

  var may = null;
  var sigDangBay = '';

  function dungMay() {
    if (may) return may;
    try {
      var b = new Blob([MA_WORKER], { type: 'application/javascript' });
      may = new Worker(URL.createObjectURL(b));
      may.onmessage = nhan;
      /* Engine không tải được, hoặc worker chết giữa chừng: bỏ hẳn đường tắt.
         `chart7()` vẫn tính đồng bộ, khách chỉ mất phần nhanh. */
      may.onerror = function () { try { may.terminate(); } catch (e) {} may = null; sigDangBay = ''; };
    } catch (e) { may = null; }
    return may;
  }

  /* Chép ĐÚNG cách `chart7()` dựng chữ ký và dựng tham số. Lệch một chỗ là worker tính ra một
     lá số mà `chart7()` không bao giờ nhận, tốn công mà không ai dùng — và tệ hơn, nếu chữ ký
     khớp trong khi tham số lệch thì màn kết quả in một lá số SAI, im lặng. */
  function doc() {
    var b = state && state.bdate;
    if (!b || !b.y || !b.m || !b.d) return null;
    var sig = [b.y, b.m, b.d, state.btime, state.bplace, state.fullName].join('|');
    var hh = null, mm = 0;
    if (state.btime) {
      var p = String(state.btime).split(':');
      hh = +p[0]; mm = +(p[1] || 0);
    }
    return {
      sig: sig,
      y: b.y, m: b.m, d: b.d, hh: hh, mm: mm,
      place: state.bplace || 'New York, USA',
      name: state.fullName || state.name || 'Friend',
      q7: state.q7 || null
    };
  }

  function nhan(e) {
    var d = e.data || {};
    if (!d.sig || d.sig !== sigDangBay) return;   /* kết quả của một lượt đã cũ */
    sigDangBay = '';
    if (d.loi || !d.chart) return;                /* engine từ chối nơi sinh — để chart7() tự xử */

    var bay = doc();
    if (!bay || bay.sig !== d.sig) return;        /* khách vừa sửa ngày sinh hoặc tên */

    try {
      /* Chỉ nạp khi ô đệm chưa giữ đúng lượt này. Không đè lên kết quả main thread vừa tính —
         hai bên cùng một engine, cùng tham số, nhưng đè thì thêm một đường cho sai lệch. */
      if (_chartSig !== d.sig || !_chart) {
        _chart = d.chart;
        _chartSig = d.sig;
        _chartErr = null;
      }
    } catch (err) { /* bundle đổi tên biến đệm → bỏ đường tắt, không làm hỏng gì */ }
  }

  function thu() {
    var v = doc();
    if (!v) return;
    if (v.sig === sigDangBay) return;             /* đang tính đúng lượt này */
    try { if (_chartSig === v.sig && _chart) return; } catch (e) { return; }  /* đã có sẵn */
    var w = dungMay();
    if (!w) return;
    sigDangBay = v.sig;
    try { w.postMessage(v); } catch (e) { sigDangBay = ''; }
  }

  /* Bọc `goto` — chỗ duy nhất mọi lần đổi màn đều đi qua. `setTimeout` để việc gửi rơi xuống sau
     khi màn mới đã vẽ xong: dựng dữ liệu cho worker cũng tốn vài mili giây, đừng cộng nó vào
     nhịp chuyển màn. */
  var gotoGoc = goto;
  goto = function () {
    var kq = gotoGoc.apply(this, arguments);
    setTimeout(thu, 0);
    return kq;
  };
})();
